export default __webpack_public_path__ + "09a744f779777dbc79038a23b9bf4f52.png";